import React, { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
  Chip,
  Button,
  Tabs,
  Tab,
  Divider,
  Menu,
  MenuItem,
  IconButton,
  Backdrop,
  CircularProgress,
  Paper,
} from '@mui/material';
import {
  Business,
  Assignment,
  Payment,
  AccountCircle,
  Email,
  Event,
  CheckCircle,
  Pending,
  Warning,
  Download,
  AccountBalance,
  Timeline,
  AddCircle,
  MoreVert,
  Description,
  People,
  CorporateFare,
  Receipt,
  CalendarToday,
  LocationOn,
  Category,
  Work,
  HowToReg,
} from '@mui/icons-material';
import OfficerManagement from '../officer_management';
import { useNavigate } from 'react-router-dom';

const mockCompanies = [
  {
    UpdatedAt: '2025-05-02T22:04:39.790Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'London',
      street: '1 Tech Park',
      postalCode: 'SW1A 1AA',
    },
    CompanyNumber: 'COMP10417949',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: 'f19c8ec3-ac6f-4e1a-be08-93f0236b9189',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: '900ea1d6-f303-4e3e-8b45-c08e933355dd',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: 'Not started trading',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: '0714855a-1fab-4c71-8b27-27c9783a1691',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '91502bbc-1806-4174-9840-bbe8e8b2948d',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '7a781bdb-0a81-4c7e-985a-1970e223c8d9',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Tech Innovations Ltd',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Private Limited Company',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [],
      directors: [
        {
          role: 'director',
          nationality: 'British',
          name: 'John Smith',
          serviceAddress: {
            city: 'London',
            street: '1 Tech Park',
            postalCode: 'SW1A 1AA',
          },
          dateOfBirth: '1980-05-15',
          id: 'dir_e4c86494-51e9-4452-9e26-379dd6f7ea2e',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:04:39.790Z',
    SICCodes: ['62012', '62020'],
    UserId: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    CompanyId: 'COMP10417949',
  },
  {
    UpdatedAt: '2025-05-02T22:10:14.888Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'Manchester',
      street: '100 Professional Avenue',
      postalCode: 'M2 3AB',
    },
    CompanyNumber: 'COMP974723CB',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: 'ee771107-8380-4351-8ca0-efaef3d0da24',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: 'e88aac00-3d0c-423b-86d7-69b89765b35d',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: 'Not started trading',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: '70932631-c862-4d89-9b7a-2ef804bf4185',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '3404aad4-b231-4177-94f2-37ef3ca9280f',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '9bd333d9-5934-4a2c-a25f-909fc10e00dd',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Elite Consultants LLP',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Limited Liability Partnership',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [
        {
          name: 'Admin Services Ltd',
          serviceAddress: {
            city: 'Manchester',
            street: '100 Professional Avenue',
            postalCode: 'M2 3AB',
          },
          role: 'secretary',
          id: 'sec_80cf2905-83b6-4bda-aae5-894e54c64155',
          appointedOn: '2025-05-02',
        },
      ],
      directors: [
        {
          role: 'director',
          occupation: 'Accountant',
          nationality: 'British',
          name: 'Sarah Johnson',
          serviceAddress: {
            city: 'Manchester',
            street: '100 Professional Avenue',
            postalCode: 'M2 3AB',
          },
          dateOfBirth: '1978-03-10',
          id: 'dir_9a12b7c5-7677-4bb9-b774-16f2faed1fd6',
          appointedOn: '2025-05-02',
        },
        {
          role: 'director',
          occupation: 'Tax Advisor',
          nationality: 'British',
          name: 'Michael Brown',
          serviceAddress: {
            city: 'Manchester',
            street: '100 Professional Avenue',
            postalCode: 'M2 3AB',
          },
          dateOfBirth: '1982-07-25',
          id: 'dir_9fc27206-7314-4a4a-a5e2-28edd1058b55',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:10:14.888Z',
    SICCodes: ['69201'],
    UserId: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    CompanyId: 'COMP974723CB',
  },
  {
    UpdatedAt: '2025-05-02T22:10:53.148Z',
    AccountsDueDate: '2027-02-02',
    RegisteredAddress: {
      country: 'United Kingdom',
      isPublic: true,
      city: 'Birmingham',
      street: 'Unit 5 Digital Park',
      postalCode: 'B1 2AB',
    },
    CompanyNumber: 'COMP98797B68',
    Status: 'ACTIVE',
    Tax: {
      corporationTaxRegistered: false,
      vatRegistered: false,
      payeRegistered: false,
    },
    ComplianceTimeline: [
      {
        due: '2026-05-02',
        penalty: '£250 to £1,500 if late',
        description: 'Annual statement confirming company details',
        legalRequirement: true,
        id: '5fa040c4-337f-413d-a4ae-bdddcaded5cc',
        title: 'File Confirmation Statement (CS01)',
        category: 'legal',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2027-02-02',
        penalty: '£150 to £1,500 if late',
        description: 'First accounts due 21 months after incorporation',
        legalRequirement: true,
        id: '06007cfe-ea91-447f-addf-f21f5c8f6ae6',
        title: 'File First Accounts (AA01)',
        category: 'financial',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '2024-04-15',
        penalty: 'Potential fines + backdated tax',
        description:
          'Must register within 3 months of starting business activity',
        legalRequirement: true,
        id: 'ba87fd27-d389-4439-9a89-d2e167196da9',
        title: 'Register for Corporation Tax (CT41G)',
        category: 'tax',
        priority: 'high',
        status: 'pending',
      },
      {
        due: '',
        penalty: 'Fines + backdated VAT if late',
        description: 'Required if taxable turnover exceeds £90,000',
        legalRequirement: false,
        id: '9e7ec204-b858-4227-b79b-a3606cab8023',
        title: 'VAT Registration',
        category: 'tax',
        priority: 'conditional',
        status: 'not-applicable',
      },
      {
        due: '',
        penalty: 'Fines if late',
        description: 'Required if employing staff or paying directors',
        legalRequirement: false,
        id: '3f7fca5a-8bf7-49ca-b37d-3708c4e0f760',
        title: 'PAYE Registration',
        category: 'payroll',
        priority: 'conditional',
        status: 'not-applicable',
      },
    ],
    CompanyName: 'Online Retail UK Ltd',
    IncorporationDate: '2025-05-02',
    ConfirmationDueDate: '2026-05-02',
    CompanyType: 'Private Limited Company',
    ShareStructure: {
      shareClasses: [
        {
          currency: 'GBP',
          votingRights: true,
          type: 'ordinary',
          valuePerShare: 1,
          totalShares: 100,
        },
      ],
      statementOfCapital: {
        totalAmount: 100,
        totalShares: 100,
      },
    },
    Officers: {
      secretaries: [
        {
          name: 'Digital Nomads Ltd',
          serviceAddress: 'same',
          role: 'secretary',
          id: 'sec_83226a0b-8d60-426f-8e50-7d6451c197f8',
          appointedOn: '2025-05-02',
        },
      ],
      directors: [
        {
          role: 'director',
          nationality: 'Chinese',
          name: 'Emma Zhang',
          serviceAddress: 'same',
          dateOfBirth: '1992-09-05',
          id: 'dir_2db7a614-d711-4e38-b918-73f2c81b431b',
          appointedOn: '2025-05-02',
        },
        {
          role: 'director',
          nationality: 'British',
          name: 'James Wilson',
          serviceAddress: 'same',
          dateOfBirth: '1988-12-12',
          id: 'dir_989ab57c-d83d-42ef-8dd1-044206fe3dbb',
          appointedOn: '2025-05-02',
        },
      ],
    },
    CreatedAt: '2025-05-02T22:10:53.148Z',
    SICCodes: ['47910'],
    UserId: 'e6429264-a051-7038-ccb5-aa02b1c15362',
    CompanyId: 'COMP98797B68',
  },
];
const getStatusChip = (status) => {
  switch (status?.toLowerCase()) {
    case 'active':
      return (
        <Chip
          icon={<CheckCircle fontSize="small" />}
          label="Active"
          color="success"
          variant="outlined"
        />
      );
    case 'pending':
      return (
        <Chip
          icon={<Pending fontSize="small" />}
          label="Pending"
          color="warning"
          variant="outlined"
        />
      );
    default:
      return (
        <Chip
          icon={<Warning fontSize="small" />}
          label={status || 'Unknown'}
          color="error"
          variant="outlined"
        />
      );
  }
};

const UserDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [selectedCompanyIndex, setSelectedCompanyIndex] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [companies, setCompanies] = useState(mockCompanies);
  const navigate = useNavigate();
  const [showOfficerMgmtPage, setShowOfficerMgmtPage] = useState(false);

  // useEffect(() => {
  //   const fetchCompanies = async () => {
  //     try {
  //       setLoading(true);
  //       const data = await getCompaniesRegisteredByLoggedInUser();
  //       setCompanies(data);
  //     } catch (err) {
  //       console.error('Failed to fetch companies:', err);
  //       setCompanies([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchCompanies();
  // }, []);

  const handleCompanyChange = (event, newValue) => {
    setSelectedCompanyIndex(newValue);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const formatDate = (dateString) => {
    if (!dateString || dateString === 'Not started trading') return 'N/A';
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const getTaskIcon = (category) => {
    switch (category) {
      case 'legal':
        return <Description color="primary" />;
      case 'financial':
        return <Receipt color="primary" />;
      case 'tax':
        return <AccountBalance color="primary" />;
      case 'payroll':
        return <Work color="primary" />;
      default:
        return <Assignment color="primary" />;
    }
  };

  const formatAddress = (address) => {
    if (typeof address === 'string') return address;
    if (!address) return 'N/A';
    return `${address.street}, ${address.city}, ${address.postalCode}, ${address.country}`;
  };

  const currentCompany = companies[selectedCompanyIndex];

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 4,
        }}
      >
        <Typography variant="h4" component="h1" fontWeight="bold">
          Business Portfolio
        </Typography>
        <Box>
          <Button
            variant="contained"
            startIcon={<AddCircle />}
            sx={{ mr: 1 }}
            onClick={() => navigate('/packages')}
          >
            Register New Company
          </Button>
          <Button
            variant="outlined"
            disabled //={companies.length === 0}
            startIcon={<Download />}
          >
            Export All
          </Button>
        </Box>
      </Box>

      {/* Company Selector */}
      <Paper elevation={2} sx={{ mb: 4, p: 1 }}>
        <Tabs
          value={selectedCompanyIndex}
          onChange={handleCompanyChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {companies.map((company, index) => (
            <Tab
              key={company.CompanyId}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <CorporateFare sx={{ mr: 1 }} />
                  {company.CompanyName}
                </Box>
              }
              sx={{ minHeight: 64 }}
            />
          ))}
        </Tabs>
      </Paper>

      {companies.length === 0 && !loading && (
        <Card elevation={2} sx={{ mb: 4, p: 4, textAlign: 'center' }}>
          <Box sx={{ maxWidth: 500, margin: '0 auto' }}>
            <Business sx={{ fontSize: 60, color: 'text.disabled', mb: 2 }} />
            <Typography variant="h6" gutterBottom>
              No Companies Registered
            </Typography>
            <Typography color="text.secondary" sx={{ mb: 3 }}>
              You haven't registered any companies yet. Get started by
              registering your first company.
            </Typography>
            <Button variant="contained" startIcon={<AddCircle />}>
              Register Your First Company
            </Button>
          </Box>
        </Card>
      )}

      {currentCompany && (
        <Grid container spacing={4}>
          {/* Left Column - Company Details */}
          <Grid item xs={12} md={8}>
            {/* Company Overview Card */}
            <Card elevation={2}>
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                  <Avatar
                    sx={{
                      bgcolor: 'primary.main',
                      width: 56,
                      height: 56,
                      mr: 3,
                    }}
                  >
                    <Business sx={{ fontSize: 32 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="h5" component="h2" fontWeight="bold">
                      {currentCompany.CompanyName}
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      {currentCompany.CompanyType}
                    </Typography>
                  </Box>
                  <Box
                    sx={{ ml: 'auto', display: 'flex', alignItems: 'center' }}
                  >
                    {getStatusChip(currentCompany.Status)}
                    <IconButton
                      aria-label="more"
                      aria-controls="company-menu"
                      aria-haspopup="true"
                      onClick={handleMenuClick}
                      sx={{ ml: 1 }}
                    >
                      <MoreVert />
                    </IconButton>
                    <Menu
                      id="company-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={handleMenuClose} disabled>
                        <ListItemIcon>
                          <Work fontSize="small" />
                        </ListItemIcon>
                        Update Information
                      </MenuItem>
                      <MenuItem onClick={() => setShowOfficerMgmtPage(true)}>
                        <ListItemIcon>
                          <People fontSize="small" />
                        </ListItemIcon>
                        Manage Officers
                      </MenuItem>
                      <Divider />
                      <MenuItem onClick={handleMenuClose} disabled>
                        <ListItemIcon>
                          <Download fontSize="small" />
                        </ListItemIcon>
                        Download All Documents
                      </MenuItem>
                    </Menu>
                  </Box>
                </Box>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <List dense disablePadding>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <Assignment color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="Company Number"
                          secondary={currentCompany.CompanyNumber || 'N/A'}
                          secondaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <CalendarToday color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="Incorporation Date"
                          secondary={formatDate(
                            currentCompany.IncorporationDate
                          )}
                          secondaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <Category color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="SIC Codes"
                          secondary={
                            <Box component="span">
                              {currentCompany.SICCodes?.map((code, i) => (
                                <Chip
                                  key={i}
                                  label={code}
                                  size="small"
                                  sx={{ mr: 0.5, mb: 0.5 }}
                                />
                              ))}
                            </Box>
                          }
                          secondaryTypographyProps={{ component: 'div' }}
                        />
                      </ListItem>
                    </List>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <List dense disablePadding>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <LocationOn color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="Registered Address"
                          secondary={formatAddress(
                            currentCompany.RegisteredAddress
                          )}
                          secondaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <Event color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="Confirmation Due"
                          secondary={formatDate(
                            currentCompany.ConfirmationDueDate
                          )}
                          secondaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemIcon sx={{ minWidth: 40 }}>
                          <AccountBalance color="primary" />
                        </ListItemIcon>
                        <ListItemText
                          primary="Accounts Due"
                          secondary={formatDate(currentCompany.AccountsDueDate)}
                          secondaryTypographyProps={{ variant: 'body2' }}
                        />
                      </ListItem>
                    </List>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>

            {/* Compliance Timeline Card */}
            <Card elevation={2} sx={{ mt: 4 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <Timeline sx={{ mr: 1 }} /> Compliance Timeline
                </Typography>
                <List disablePadding>
                  {currentCompany.ComplianceTimeline?.map((task) => (
                    <ListItem
                      key={task.id}
                      divider
                      secondaryAction={
                        task.due && (
                          <Chip
                            label={`Due: ${formatDate(task.due)}`}
                            size="small"
                            color={
                              task.status === 'completed'
                                ? 'default'
                                : 'warning'
                            }
                            variant="outlined"
                          />
                        )
                      }
                    >
                      <ListItemIcon sx={{ minWidth: 40 }}>
                        {getTaskIcon(task.category)}
                      </ListItemIcon>
                      <ListItemText
                        primary={task.title}
                        primaryTypographyProps={{ fontWeight: 'medium' }}
                        secondary={
                          <Box component="span">
                            {task.description}
                            {task.penalty && (
                              <Typography
                                variant="caption"
                                display="block"
                                color="error"
                              >
                                Penalty: {task.penalty}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Grid>

          {/* Right Column - Additional Info */}
          <Grid item xs={12} md={4}>
            {/* Directors Card */}
            <Card elevation={2}>
              <CardContent>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <People sx={{ mr: 1 }} /> Officers
                </Typography>

                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  gutterBottom
                >
                  Directors
                </Typography>
                <List disablePadding>
                  {currentCompany.Officers?.directors?.map((director) => (
                    <ListItem key={director.id} disableGutters>
                      <ListItemIcon sx={{ minWidth: 40 }}>
                        <Avatar sx={{ width: 32, height: 32 }}>
                          <AccountCircle />
                        </Avatar>
                      </ListItemIcon>
                      <ListItemText
                        primary={director.name}
                        secondary={
                          <Box component="span">
                            <Typography variant="caption" display="block">
                              Since {formatDate(director.appointedOn)}
                            </Typography>
                            {director.occupation && (
                              <Typography variant="caption" display="block">
                                {director.occupation}
                              </Typography>
                            )}
                          </Box>
                        }
                      />
                      {/* <Chip
                        label="Director"
                        size="small"
                        color="primary"
                        variant="outlined"
                      /> */}
                    </ListItem>
                  ))}
                </List>

                {currentCompany.Officers?.secretaries?.length > 0 && (
                  <>
                    <Typography
                      variant="subtitle2"
                      color="text.secondary"
                      gutterBottom
                      sx={{ mt: 2 }}
                    >
                      Secretaries
                    </Typography>
                    <List disablePadding>
                      {currentCompany.Officers?.secretaries?.map(
                        (secretary) => (
                          <ListItem key={secretary.id} disableGutters>
                            <ListItemIcon sx={{ minWidth: 40 }}>
                              <Avatar sx={{ width: 32, height: 32 }}>
                                <HowToReg />
                              </Avatar>
                            </ListItemIcon>
                            <ListItemText
                              primary={secretary.name}
                              secondary={`Since ${formatDate(secretary.appointedOn)}`}
                            />
                          </ListItem>
                        )
                      )}
                    </List>
                  </>
                )}
              </CardContent>
            </Card>

            {/* Tax Status Card */}
            <Card elevation={2} sx={{ mt: 4 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  component="h3"
                  gutterBottom
                  sx={{ display: 'flex', alignItems: 'center' }}
                >
                  <AccountBalance sx={{ mr: 1 }} /> Tax Status
                </Typography>
                <List disablePadding>
                  <ListItem>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      {currentCompany.Tax?.corporationTaxRegistered ? (
                        <CheckCircle color="success" />
                      ) : (
                        <Pending color="warning" />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary="Corporation Tax"
                      secondary={
                        currentCompany.Tax?.corporationTaxRegistered
                          ? 'Registered'
                          : 'Not registered'
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      {currentCompany.Tax?.vatRegistered ? (
                        <CheckCircle color="success" />
                      ) : (
                        <Pending color="warning" />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary="VAT"
                      secondary={
                        currentCompany.Tax?.vatRegistered
                          ? 'Registered'
                          : 'Not registered'
                      }
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon sx={{ minWidth: 40 }}>
                      {currentCompany.Tax?.payeRegistered ? (
                        <CheckCircle color="success" />
                      ) : (
                        <Pending color="warning" />
                      )}
                    </ListItemIcon>
                    <ListItemText
                      primary="PAYE"
                      secondary={
                        currentCompany.Tax?.payeRegistered
                          ? 'Registered'
                          : 'Not registered'
                      }
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            {/* Quick Actions Card */}
            <Card elevation={2} sx={{ mt: 4 }}>
              <CardContent>
                <Typography variant="h6" component="h3" gutterBottom>
                  Quick Actions
                </Typography>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      startIcon={<Email />}
                      sx={{ mb: 1 }}
                    >
                      Contact Support
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<Assignment />}
                      sx={{ mb: 1 }}
                    >
                      File Confirmation
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<Payment />}
                      sx={{ mb: 1 }}
                    >
                      Make Payment
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<Timeline />}
                    >
                      View Filing History
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      <Backdrop
        open={loading}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <OfficerManagement
        company={companies[selectedCompanyIndex]}
        open={showOfficerMgmtPage}
        onClose={() => setShowOfficerMgmtPage(false)}
        onSave={() => console.log('on officer update')}
      />
    </Container>
  );
};

export default UserDashboard;
